import React from 'react';
import ReactDOM from 'react-dom';
import { createHashHistory } from 'history';

import { Router, Route, useRouterHistory, IndexRedirect } from 'react-router';

import { syncHistoryWithStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import Home from './components/home/Home'
import List from './components/list/List'
// import ListApp from './components/list/ListApp'
// import AddList from './components/addList/AddList'
import Collect from './components/collect/Collect'
// import Project from './components/project/Project'
// import ProjectApp from './components/project/ProjectApp'
// import Scheme from './components/scheme/Scheme'
// import SchemeApp from './components/scheme/SchemeApp'
// import SchemeDoc from './components/scheme/SchemeDoc'
import Order from './components/order/Order'
import Login from './components/init/Login'
import Reward from './components/reward/Reward'
// import Register from './components/init/Register'
import Search from './components/home/Search';
import CollectList from './components/mode/CollectList';
import OrderList from './components/mode/OrderList';
import AppDetail from './components/mode/appDetail/index';
import CaseParticulars from './components/case/particulars';
import EcodeDetail from './components/ecode/index';
import Main from './components/main';
import Workflow from './components/workflow';
import WorkflowDetail from './components/workflow/detail'
import allStore from './stores/index';
import RootComponent from './components/Root'

import './style'
import Price from "./components/price/Price";

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);

class Root extends React.Component {
  render() {
    return (
      <Provider {...allStore}>
        <Router history={history}>
          <Route name="/" breadcrumbName="根目录" path="/" component={RootComponent} >
            <IndexRedirect to="/main" />
            <Route name="/main" breadcrumbName="首页新版" path="/main" component={Main} />
            <Route name="/app" breadcrumbName="应用" path="/app" component={Home}>
              <Route name="workflow" breadcrumbName="流程" path="workflow" component={Workflow} />
              <Route name="workflowDetail" breadcrumbName="流程详情" path="workflowDetail/:id" component={WorkflowDetail} />
              <Route name="list" breadcrumbName="查询" path="list" component={List} />
              {/*<Route name="listapp" breadcrumbName="应用详情" path="listapp" component={ListApp}/>*/}
              {/*<Route name="addlist" breadcrumbName="添加列表" path="addlist" component={AddList}/>*/}
              <Route name="collect" breadcrumbName="我的收藏" path="collect" component={Collect} />
              {/*<Route name="project" breadcrumbName="我的项目" path="project" component={Project}/>*/}
              {/*<Route name="projectapp" breadcrumbName="我的项目应用列表" path="projectapp" component={ProjectApp}/>*/}
              {/*<Route name="scheme" breadcrumbName="我的方案" path="scheme" component={Scheme}/>*/}
              {/*<Route name="schemeapp" breadcrumbName="我的方案应用列表" path="schemeapp" component={SchemeApp}/>*/}
              {/*<Route name="schemedoc" breadcrumbName="我的方案文档" path="schemedoc" component={SchemeDoc}/>*/}
              <Route name="order" breadcrumbName="订单" path="order" component={Order} />
              <Route name="reward" breadcrumbName="奖励排名" path="reward" component={Reward} />
              {/*应用报价展示*/}
              <Route name="price" breadcrumbName="应用报价" path="price" component={Price} />
              <Route name="search" breadcrumbName="分类搜索" path="search" component={Search} />
              <Route name="collectList" breadcrumbName="应用收藏" path="collectList" component={CollectList} />
              <Route name="orderList" breadcrumbName="应用订单" path="orderList" component={OrderList} />
              <Route name="appDetail" breadcrumbName="应用详情页" path="appDetail/:id" component={AppDetail} />
              {/* <Route name="caseParticulars" breadcrumbName="案例库详情" path="caseParticulars/:id" component={CaseParticulars} /> */}
            </Route>
            <Route name="login" breadcrumbName="登录" path="login" component={Login} />
            {/*<Route name="register" breadcrumbName="注册" path="register" component={Register} />*/}
            <Route name="ecode" breadcrumbName="云案例详细字段信息" path="ecode">
              <Route name="detail" breadcrumbName="云案例详细字段信息" path="detail" component={EcodeDetail} />
            </Route>
          </Route>
        </Router>
      </Provider>
    )
  }
}

function getParamById(id) {
  let href = window.location.href;
  const reg = new RegExp(`${id}\=[^\&^\#^\/^\:]+`);
  return href.match(reg) ? href.match(reg)[0].split('=')[1] : "";
}

setTimeout(function () {
  try {
    ReactDOM.render(<Root />, document.getElementById('root'));

    //再次获取信息
    let href = window.location.href;
    let key = href.indexOf('key=') > 0 ? getParamById("key") : '';
    let docId = href.indexOf('docId=') > 0 ? getParamById("docId") : '';
    let maxImgWidth = href.indexOf('maxImgWidth=') > 0 ? getParamById("maxImgWidth") : '';
    if(!!key) {
      allStore.initStore.reGetMe({ key, docId, maxImgWidth });
    } else {
      if((!localStorage.me || (localStorage.me && JSON.parse(localStorage.me).com === "other")) && window.location.pathname !== "/cloud" && window.location.pathname !== "/web") {
        window.location.href = "/cloud";
      }
    }

    let path = window.$("#path").html();
    !!path && history.push(path);
  } catch (e) {
    //console.log("render出错：" + e);
  }
}, window.debug ? 100 : 0);

// setInterval(function () {
//   try {
//     allStore.initStore.checkToken();
//   } catch(e) {
//     //console.log("render出错：" + e);
//   }
// },3000);


// WEBPACK FOOTER //
// ./src/index.js